import React, { useState, useEffect } from "react";
import axios from "axios";
import { SERVER_URL, AUTH_STORAGE_KEY } from "../socket";
import { loadSliderImages } from "../api/sliderApi";
import loginBg1 from "../bgimage11.jpg";
import loginBg2 from "../bgimage12.jpg";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import CommonNavbar from "../components/CommonNavbar";
import { useNavigate } from "react-router-dom";
import "../styles.css";

const brandLogo = `${process.env.PUBLIC_URL}/Krivaonelogo1.png`;
// import Header from "./Header";

// view: "login" | "forgot" | "forgot_sent"
function LoginPage() {
  const [view, setView]             = useState("login");
  const [form, setForm]             = useState({ username: "", password: "" });
  const [forgotEmail, setForgotEmail] = useState("");
  const [resetLink, setResetLink] = useState("");
  const [isInternal, setIsInternal] = useState(false);
  const [message, setMessage]       = useState("");
  const [loading, setLoading]       = useState(false);
  const [showPassword, setShowPassword] = useState(false);
const navigate = useNavigate();

  // slider
  const fallbackImages = [loginBg1, loginBg2];
  const [sliderImages, setSliderImages] = useState([]);
  const [adIndex, setAdIndex]           = useState(0);

  useEffect(() => {
    const loadImages = async () => {
      try {
        const images = await loadSliderImages();
        if (Array.isArray(images) && images.length > 0) {
          setSliderImages(images.map((img) => img.url));
        } else {
          setSliderImages(fallbackImages);
        }
      } catch {
        setSliderImages(fallbackImages);
      }
    };
    loadImages();
  }, []);
  

  const adImages = sliderImages.length > 0 ? sliderImages : fallbackImages;

  useEffect(() => {
    const t = setInterval(
      () => setAdIndex((i) => (i + 1) % adImages.length),
      3500
    );
    return () => clearInterval(t);
  }, [adImages.length]);

  // ── Login ────────────────────────────────────────────────────────────────────
  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");
    if (!form.username || !form.password) {
      setMessage("Email and password are required.");
      return;
    }
    try {
      setLoading(true);
      const res = await axios.post(`${SERVER_URL}/api/auth/login`, {
        username: form.username.trim(),
        password: form.password,
      });
      if (res.data?.token && res.data?.user) {
        localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(res.data));
        window.location.href = "/";
      } else {
        setMessage("Unexpected server response.");
      }
    } catch (err) {
      setMessage(err.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  // ── Forgot password ──────────────────────────────────────────────────────────

const handleForgot = async (e) => {
  e.preventDefault();
  setMessage("");
  const trimmedEmail = forgotEmail.trim().toLowerCase();
  if (!trimmedEmail) { setMessage("Enter your registered email address."); return; }
  if (!/^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(trimmedEmail)) {
    setMessage("Enter a valid email address.");
    return;
  }
  try {
    setLoading(true);
    const res = await axios.post(`${SERVER_URL}/api/auth/forgot-password`, {
      email: trimmedEmail,
    });

    if (res.data?.success && res.data?.token) {
      // ✅ Build the reset URL from the browser's own origin
      // This always points to the correct React app (port 3000 in dev, domain in prod)
      const link = `${window.location.origin}/reset-password?token=${res.data.token}&email=${encodeURIComponent(res.data.email || trimmedEmail)}`;
      setResetLink(link);
      setIsInternal(Boolean(res.data.internal));
      setView("forgot_sent");
      setMessage("");
    } else if (res.data?.success) {
      // Account not found (server hides this) — show generic sent message
      setResetLink("");
      setIsInternal(false);
      setView("forgot_sent");
    } else {
      setMessage(res.data?.error || "Something went wrong.");
    }
  } catch (err) {
    setMessage(err.response?.data?.error || "Failed to process request.");
  } finally {
    setLoading(false);
  }
};



  const switchView = (v) => { setView(v); setMessage(""); };

  // ── Render right panel content based on view ─────────────────────────────────
  const renderRight = () => {
    // ── Login form ────────────────────────────────────────────────────────────
    if (view === "login") {
      return (
        <>
          <center>
            <img src={brandLogo} className="imglogologin" alt="Brand Logo" />
          </center>
          {/* <h2 className="login-title">Welcome to Kriva Bharat Mail</h2> */}

          {message && <div className="login-error">{message}</div>}

          <form onSubmit={handleLogin} className="login-form">
            <label>Email Address</label>
            <input
              name="username"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              placeholder="username@krivamail.com"
              autoComplete="username"
            />

            <label style={{ marginTop: 10 }}>Password</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                placeholder="••••••••"
                autoComplete="current-password"
              />
              <span
                className="password-toggle"
                onClick={() => setShowPassword((p) => !p)}
              >
                {showPassword
                  ? <AiOutlineEyeInvisible size={18} />
                  : <AiOutlineEye size={18} />}
              </span>
            </div>

            {/* Forgot password link */}
            <div style={{ textAlign: "right", margin: "6px 0 2px" }}>
              <button
                type="button"
                className="link-btn"
                onClick={() => switchView("forgot")}
              >
                Forgot Password?
              </button>
            </div>

            <div className="login-actions">
              <button type="submit" disabled={loading}>
                {loading ? "Signing in..." : "Login"}
              </button>
            </div>
          </form>

          <div className="login-footer" style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <a href="/register">Create a new account</a>
            {/* <a href="/privacy-policy">Privacy Policy</a> */}
          </div>
        </>
      );
    }

    // ── Forgot password — enter email ─────────────────────────────────────────
    if (view === "forgot") {
      return (
        <>
          <center>
            <img src={brandLogo} className="imglogo" alt="Brand Logo" />
          </center>
          <h2 className="login-title">Forgot Password</h2>
          <p style={{ fontSize: 14, color: "#64748b", marginBottom: 16 }}>
            Enter your registered email. A reset link will be sent to your recovery email address.
          </p>

          {message && <div className="login-error">{message}</div>}

          <form onSubmit={handleForgot} className="login-form">
            <label>Registered Email</label>
            <input
              type="email"
              value={forgotEmail}
              onChange={(e) => setForgotEmail(e.target.value)}
              placeholder="username@krivamail.com"
              autoFocus
            />

            <div className="login-actions" style={{ marginTop: 16 }}>
              <button type="submit" disabled={loading}>
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </div>
          </form>

          <div className="login-footer">
            <button
              type="button"
              className="link-btn"
              onClick={() => switchView("login")}
            >
              ← Back to Login
            </button>
          </div>
        </>
      );
    }

    // ── Forgot password — sent confirmation ───────────────────────────────────
   
if (view === "forgot_sent") {
  return (
    <>
      <center>
        <img src={brandLogo} className="imglogo" alt="Brand Logo" />
      </center>

      <h2 className="login-title">Reset Your Password</h2>

      {resetLink ? (
        // Token was returned — show actionable reset button
        <div className="success-box" style={{ textAlign: "left" }}>
          {isInternal && (
            <p style={{ marginBottom: 12, color: "#1e40af", fontSize: 14 }}>
              ✅ A reset notification has been delivered to the recovery email's
              inbox on this platform.
            </p>
          )}
          <p style={{ marginBottom: 16, fontSize: 14, color: "#374151" }}>
            Click the button below to set your new password.
            This link expires in <strong>1 hour</strong>.
          </p>

          {/* Primary action button */}
          <a
            href={resetLink}
            className="btn-primary"
            style={{
              display: "inline-block",
              textDecoration: "none",
              padding: "11px 28px",
              borderRadius: 8,
              fontSize: 15,
              marginBottom: 16,
            }}
          >
            Set New Password →
          </a>

          {/* Copyable link fallback */}
          <div
            style={{
              padding: "8px 12px",
              background: "#f8fafc",
              borderRadius: 6,
              fontSize: 12,
              color: "#475569",
              wordBreak: "break-all",
              cursor: "pointer",
              border: "1px solid #e2e8f0",
            }}
            title="Click to copy link"
            onClick={() => navigator.clipboard?.writeText(resetLink)}
          >
            🔗 {resetLink}
            <span style={{ marginLeft: 8, color: "#94a3b8" }}>
              (click to copy)
            </span>
          </div>
        </div>
      ) : (
        // Account not found — generic message (don't reveal)
        <div className="success-box">
          <p>
            If an account with that email exists and has a recovery email set,
            the reset information has been sent.
          </p>
        </div>
      )}

      <div className="login-footer" style={{ marginTop: 20 }}>
        <button
          type="button"
          className="link-btn"
          onClick={() => { switchView("login"); setResetLink(""); }}
        >
          ← Back to Login
        </button>
      </div>
    </>
  );
}


  };

  return (
    <>
     <CommonNavbar
  searchQuery={""}
  setSearchQuery={() => {}}   // ← dummy, not needed
  onSearch={(q) => {
    if (q.trim()) {
      navigate(`/?search=${encodeURIComponent(q.trim())}`);
    }
  }}
/>
      <div className="login-page" style={{ marginTop: 60 }}>
        <div className="login-layout">
          {/* Left — slider */}
          <div className="ad-card">
            <div className="ad-media">
              <img src={adImages[adIndex]} alt="advertisement" className="ad-image" />
            </div>
          </div>

          {/* Right — dynamic panel */}
          <div className="login-card">
            {renderRight()}
          </div>
        </div>
      </div>
       
    </>
  );
}

export default LoginPage;
